import { useSelector } from 'react-redux';
import {
    selectUser,
    selectIsLoggedIn,
    selectIsRefreshing,
    generationQRCode,
    tokenUser,
    idUserAccount,
    verificationToken
} from './Auth/selectors';

const useAuth = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isRefreshing = useSelector(selectIsRefreshing);
  const user = useSelector(selectUser);
  const QRCode = useSelector(generationQRCode);
  const tokenAccount = useSelector(tokenUser);
  const idUser = useSelector(idUserAccount)
  const verificationTokenUser = useSelector(verificationToken);

  return {
    isLoggedIn,
    isRefreshing,
    user,
    QRCode,
    tokenAccount,
    idUser,
    verificationTokenUser
  };
};

export default useAuth